import React, { Children, useMemo, FunctionComponent } from 'react';

import useSummaryState from './state/summary';
import useFilterState from './state/filter';
import useLoadersState from './state/loaders';
import useVaultState from './state/vault';
import useSearchState from './state/search';
import useDetailsCardState from './state/detailsCard';
import useNotificationState from './state/notification';
import usePaymentsSheetState from './state/payments';
import useSubscriptionDataState from './state/subscriptionData';

import DashboardContext, { DashboardContextType } from './Context';

function useProviderValue(): DashboardContextType {
    const summaryState = useSummaryState();
    const filterState = useFilterState();
    const loadersState = useLoadersState();
    const vaultState = useVaultState();
    const searchState = useSearchState();
    const detailsCardState = useDetailsCardState();
    const notificationSubSwitchingState = useNotificationState();
    const paymentsSheetState = usePaymentsSheetState();
    const subscriptionDataState = useSubscriptionDataState();

    return useMemo(
        () => ({
            paymentsSheetState,
            summaryState,
            filterState,
            loadersState,
            vaultState,
            searchState,
            detailsCardState,
            notificationSubSwitchingState,
            subscriptionDataState,
        }),
        [
            paymentsSheetState,
            summaryState,
            filterState,
            loadersState,
            vaultState,
            searchState,
            detailsCardState,
            notificationSubSwitchingState,
            subscriptionDataState,
        ],
    );
}

type DashboardProviderProps = {
    children: React.ReactNode;
};

const DashboardProvider: FunctionComponent<DashboardProviderProps> = ({ children }) => {
    const value = useProviderValue();

    return (
        <DashboardContext.Provider value={value}>
            {Children.only(children)}
        </DashboardContext.Provider>
    );
};

export default DashboardProvider;
